import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  requestRetrieveFrequentlyAskedQuestions,
  requestUpdateFrequentlyAskedQuestions,
} from '../../../api/help/help.actions';

import FrequentlyAskedQuestions from '../../../components/screens/help-center/frequently-asked-questions/FrequentlyAskedQuestions';

const FrequentlyAskedQuestionsContainer = () => {
  const userGroups = useSelector(({ party }) => party.userGroups);
  const frequentlyAskedQuestions = useSelector(({ helpCenter }) => helpCenter.frequentlyAskedQuestions);

  const dispatch = useDispatch();

  const isAdmin = userGroups.includes('admin');

  useEffect(() => {
    dispatch(requestRetrieveFrequentlyAskedQuestions());
  }, [dispatch]);

  const updateFrequentlyAskedQuestions = (frequentlyAskedQuestions) => {
    dispatch(
      requestUpdateFrequentlyAskedQuestions({
        input: {
          faqString: frequentlyAskedQuestions,
        },
      })
    );
  };

  return (
    <FrequentlyAskedQuestions
      isAdmin={isAdmin}
      frequentlyAskedQuestions={frequentlyAskedQuestions}
      updateFrequentlyAskedQuestions={updateFrequentlyAskedQuestions}
    />
  );
};

export default FrequentlyAskedQuestionsContainer;
